export const MAX_FOLDER_NAME_LENGTH = 50;

export const folderNameTooLongMessage = `Der Name darf maximal ${MAX_FOLDER_NAME_LENGTH} Zeichen haben.`;

export function isFolderNameTooLong(name: string): boolean {
  return name.trim().length > MAX_FOLDER_NAME_LENGTH;
}
